import { VerticalHeroTabs } from "../../../-components/VerticalHeroTabs"
import { data } from "./_data"

export const SitemapEditor = () => {
    return (
            <VerticalHeroTabs
                headline={{ heading: "Powerful visual sitemap editor", subheading: 'Use our feature-packed drag and drop editor to view, edit, and collaborate on your sitemap with your team. All available for free in your browser with nothing to install.' }}
                data={data}
            />
    )
}